// https://www.digitalocean.com/community/tutorials/vuejs-lodash-throttle-debounce
// oppure
const crypto = require('crypto')

export function debounce(fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export const dynamicSort = function (property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
      * and you may want to customize it to your needs
    */
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

export const dynamicSortMultiple = function () {
  /*
   * save the arguments object as it will be overwritten
   * note that arguments object is an array-like object
   * consisting of the names of the properties to sort by
   */
  var props = arguments
  return function (obj1, obj2) { // utilizzare "-nome" per descending
    var i = 0
    var result = 0
    var numberOfProperties = props.length
    /* try getting a different result from 0 (equal)
      * as long as we have extra properties to compare
      */
    while (result === 0 && i < numberOfProperties) {
      result = dynamicSort(props[i])(obj1, obj2)
      i++
    }
    return result
  }
}

export const sanitize = function (text, toLower) {
  const pattern = /[^a-zA-Z0-9-_]+/gi
  const res = text.replace(pattern, '_')
  return toLower ? res.toLowerCase() : res
}

export const downloadXml = function (document, fileName, xml, base64) {
  const linkSource = `data:text/plain;charset=utf-8${base64 ? ';base64' : ''},` + encodeURIComponent(xml)
  const downloadLink = document.createElement("a")

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const downloadTxt = function (document, fileName, txt) {
  const linkSource = `data:text/plain;charset=utf-8,` + encodeURIComponent(txt)
  const downloadLink = document.createElement("a")

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const downloadPdf = function (document, fileName, pdf, base64) {
  const linkSource = `data:application/pdf${base64 ? ';base64' : ''},` + encodeURIComponent(pdf)
  const downloadLink = document.createElement("a")

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const downloadZip = function (document, fileName, zip, base64) {
  const linkSource = `data:application/zip${base64 ? ';base64' : ''},` + encodeURIComponent(zip)
  const downloadLink = document.createElement("a")

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const getAnnoRiferimento = function (data) {
  if (typeof data === 'string') {
    data = new Date(data)
  }
  try {
    return data.getFullYear()
  } catch {
    console.log('errore data', data)
    return (new Date()).getFullYear()
  }
}

export const capitalizeFirstLetter = function ([first = '', ...rest]) {
  return [first.toUpperCase(), ...rest].join('')
}

export const ordinaLotti = function (lotti, gestione, qtaRichiesta) {
  // TODO: implementare gestione --> lotti.gestione.criterioConsumoScarico.codice

  let lottiOrdinati = lotti
  return lottiOrdinati
}

export const calcolaHash = function (obj) {
  // -----------------------------------------
  // Eliminare dal calcolo eventuali parametri che non devono essere verificati in modifica
  // es.: delete obj.riordino
  // ------------------------------------------
  const value = JSON.stringify(obj)
  var hash = 0;
  if (value.length === 0) return hash;
  for (let i = 0; i < value.length; i++) {
    const ch = value.charCodeAt(i);
    hash = ((hash << 5) - hash) + ch;
    hash = hash & hash;
  }
  return hash;
}

export const delay = function (time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export const slugify = (text) => {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
}

export const randomHex = function (len) {
  return crypto.randomBytes(len).toString('hex')
}
